import {useAppDispatch, useAppSelector} from "../hooks";
import {selectFrontingMembers} from "../redux/members";
import {addMessage} from "../redux/messages";
import {v7 as uuid7} from "uuid";
import {MessageType} from "../api/Models";

export default function useMessageLogic() {
  const fronts = useAppSelector(selectFrontingMembers)
  const dispatch = useAppDispatch();

  const addSimpleMessage = (msg: string, type: MessageType, authorIds: string[] = []) => {
    dispatch(addMessage({
      id: uuid7(),
      type,
      entry: msg,
      authorIds,
      createdAt: new Date(),
      updatedAt: null
    }))
  }

  const addErrorMessage = (msg: string) => {
    addSimpleMessage(msg, MessageType.Error)
  };

  const addNoticeMessage = (msg: string) => {
    addSimpleMessage(msg, MessageType.Notice)
  };

  const addSuccessMessage = (msg: string) => {
    addSimpleMessage(msg, MessageType.Success)
  };

  const addUserMessage = (msg: string) => {
    addSimpleMessage(msg, MessageType.User, fronts.map((f) => f.id))
  }

  return {
    addErrorMessage,
    addNoticeMessage,
    addSuccessMessage,
    addUserMessage,
    addSimpleMessage
  };
}